import { useSyncExternalStore } from "react";

const KEY = "iuvo-dark";
const listeners = new Set<() => void>();

let dark = (() => {
  try {
    return localStorage.getItem(KEY) === "true";
  } catch {
    return false;
  }
})();

function apply() {
  document.body.classList.toggle("dark", dark);
}
apply();

function toggle() {
  dark = !dark;
  try {
    localStorage.setItem(KEY, String(dark));
  } catch {
    /* sem storage: vale só nesta aba */
  }
  apply();
  listeners.forEach((l) => l());
}

/** Tema claro/escuro (classe `dark` no body, como no protótipo). Preferência por navegador. */
export function useTheme() {
  const value = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => dark,
  );
  return { dark: value, toggle };
}
